import { useContext, useCallback } from "react";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import MaskService from "../../../../utils/mask/maskService";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { EmissaoContext } from "../contexts/EmissaoContext";
import { useMemo } from "react";
import { GlobalVariables } from "../../../../GlobalVariables";
import { notify } from "../../../../utils/notify";

export default function useCalculosTributacao() {
  const {
    productDataQuantity,
    productOthersFreight,
    productOthersSafe,
    productOthersDiscount,
    productOthersExpense,
    productIcmsSituation,
    productIcmsValueBc,
    setProductIcmsValueBc,
    productIcmsAliquot,
    productIcmsValue,
    setProductIcmsValue,
    productIcmsAliquotPoverty,
    setProductIcmsBcPoverty,
    setProductIcmsValuePoverty,
    productIcmsStPercentAdd,
    productIcmsStPercentReductBc,
    productIcmsStValueBc,
    setProductIcmsStValueBc,
    productIcmsStAliquot,
    setProductIcmsStValue,
    productIcmsStAliquotPoverty,
    setProductIcmsStValuePoverty,
    productIpiSituation,
    productIpiBcValue,
    setProductIpiBcValue,
    productIpiAliquot,
    setProductIpiValue,
    productIpiReturnedAliquot,
    setProductIpiReturnedValue,
    productPisSituation,
    productPisPercentAliquot,
    productPisAliquot,
    productPisBcValue,
    setProductPisBcValue,
    setProductPisValue,
    productCofinsSituation,
    productCofinsPercentAliquot,
    productCofinsAliquot,
    productCofinsBcValue,
    setProductCofinsBcValue,
    setProductCofinsValue,
    productIcmsPercentReduct,
    setProductIcmsCreditAprove,
    productIcmsAliquotCredit,
    setProductIcmsStBcPoverty,
    productIcmsStListModality,
    productIcmsListSimpleTaxationSituation,
    productIcmsListNormalTaxationSituation,
    productIcmsListModality,
    productIcmsListSource,
    prodcuctIpiListSituation,
    prodcuctPisListSituation,
    productCofinsListSituation,
    productDataUnityValue,
    productCheckIcmsFreight,
    productCheckIcmsSafe,
    productCheckIcmsOthers,
    productCheckIcmsDiscount,
    productCheckIpiFreight,
    productCheckIpiSafe,
    productCheckIpiOthers,
    productCheckIpiDiscount,
    productCheckPisFreight,
    productCheckPisSafe,
    productCheckPisOthers,
    productCheckPisDiscount,
    productCheckPisDescIcms,
    productCheckCofinsFreight,
    productCheckCofinsSafe,
    productCheckCofinsOthers,
    productCheckCofinsDiscount,
    productCheckCofinsDescIcms,
    productIcmsAliquotInterstate,
    productDataTotalValue,
  } = useContext(ParametrosProdutoContext);

  const { itensTable, nfeMontageSubtype, headerCfop } =
    useContext(EmissaoContext);

  const { queryParams } = useContext(QueryParamsContext);

  const getSuccessStats = () => {
    return [
      100, //Autorizado o uso da NF-e
      101, //Cancelamento de NF-e homologado
      102, //Inutilização de número homologado
      103, //Lote recebido com sucesso
      104, //Lote processado
      105, //Lote em processamento
      107, //Serviço em Operação
      111, //Consulta cadastro com uma ocorrência
      112, //Consulta cadastro com mais de uma ocorrência
      124, //EPEC Autorizado
      128, //Lote de Evento Processado
      135, //Evento registrado e vinculado a NF-e
      136, //Evento registrado, mas não vinculado a NF-e
      137, //Nenhum documento localizado para o Destinatário
      138, //Documento localizado para o Destinatário
      139, //Pedido de Download processado
      140, //Download disponibilizado
      150, //Autorizado o uso da NF-e, autorização fora de prazo
      151, //Cancelamento de NF-e homologado fora de prazo
      155, //C
    ];
  };

  const getRulesPisCofins = () => {
    return {
      "01": true,
      "02": true,
      "03": false,
      "04": false,
      "05": false,
      "06": false,
      "07": false,
      "08": false,
      "09": false,
      49: true,
      50: true,
      51: true,
      52: true,
      53: true,
      54: true,
      55: true,
      56: true,
      60: true,
      61: true,
      62: true,
      63: true,
      64: true,
      65: true,
      66: true,
      67: true,
      70: true,
      71: true,
      72: true,
      73: true,
      74: true,
      75: true,
      98: true,
      99: true,
    };
  };

  const getRulesPerCst = useMemo(
    () => ({
      "00": {
        OBG: false,
        Cest: false,
        modBc: true,
        vBC: true,
        pRedBC: false,
        pICMS: true,
        vICMS: true,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      10: {
        OBG: false,
        Cest: false,
        modBc: true,
        vBC: true,
        pRedBC: false,
        pICMS: true,
        vICMS: true,
        modBCST: true,
        pMVAST: true,
        pRedBCST: false,
        vBCST: true,
        pICMSST: true,
        vICMSST: true,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      20: {
        OBG: false,
        Cest: false,
        modBc: true,
        vBC: true,
        pRedBC: true,
        pICMS: true,
        vICMS: true,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
        vICMSDeson: true,
        motDesICMS: true,
      },
      30: {
        OBG: false,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: true,
        pMVAST: true,
        pRedBCST: false,
        vBCST: true,
        pICMSST: true,
        vICMSST: true,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
        vICMSDeson: true,
        motDesICMS: true,
      },
      40: {
        OBG: false,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
        vICMSDeson: true,
        motDesICMS: true,
      },
      41: {
        OBG: false,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: true,
        vICMSSTRet: true,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: true,
        vICMSDeson: true,
        motDesICMS: true,
      },
      50: {
        OBG: false,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
        vICMSDeson: true,
        motDesICMS: true,
      },
      51: {
        OBG: false,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      60: {
        OBG: false,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: true,
        pICMSST: false,
        vICMSST: true,
        vBCSTret: true,
        vICMSSTRet: true,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      70: {
        OBG: false,
        Cest: false,
        modBc: true,
        vBC: true,
        pRedBC: true,
        pICMS: true,
        vICMS: true,
        modBCST: true,
        pMVAST: true,
        pRedBCST: false,
        vBCST: true,
        pICMSST: true,
        vICMSST: true,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
        vICMSDeson: true,
        motDesICMS: true,
      },
      90: {
        OBG: false,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
        vICMSDeson: true,
        motDesICMS: true,
      },
      101: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: nfeMontageSubtype === "D" ? true : false,
        vCredICMSSN: true,
        vBCSTFCPRet: false,
      },
      102: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      103: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      201: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: true,
        pMVAST: true,
        pRedBCST: false,
        vBCST: true,
        pICMSST: true,
        vICMSST: true,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: true,
        vCredICMSSN: true,
        vBCSTFCPRet: false,
      },
      202: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: true,
        pMVAST: true,
        pRedBCST: false,
        vBCST: true,
        pICMSST: true,
        vICMSST: true,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      203: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: true,
        pMVAST: true,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: true,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      300: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      400: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      500: {
        OBG: true,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: false,
        vCredICMSSN: false,
        vBCSTFCPRet: false,
      },
      900: {
        OBG: false,
        Cest: false,
        modBc: false,
        vBC: false,
        pRedBC: false,
        pICMS: false,
        vICMS: false,
        modBCST: false,
        pMVAST: false,
        pRedBCST: false,
        vBCST: false,
        pICMSST: false,
        vICMSST: false,
        vBCSTret: false,
        vICMSSTRet: false,
        pCredSN: true,
        vCredICMSSN: true,
        vBCSTFCPRet: false,
      },
    }),
    [nfeMontageSubtype]
  );

  const rmd = (value = "", fixed = 2) => {
    if (typeof value === "number") return parseFloat(value.toFixed(fixed));

    if (typeof value !== "string" || value === "") return 0;

    return parseFloat(
      parseFloat(value.replace(/\./g, "").replace(",", ".")).toFixed(fixed)
    );
  };

  /* Valor Final Calculado pela Aliquota % */
  const calcByAliquot = (bc, percentAliquot) => {
    return bc * (percentAliquot / 100);
  };

  /* Valor Final Calculado pelo Valor em R$  */
  const calcByValue = (valueAliquot, productQuantity) => {
    return valueAliquot * productQuantity;
  };

  const getStatesTaxations = useCallback(() => {
    return {
      ICMS: {
        frete: productCheckIcmsFreight,
        seguro: productCheckIcmsSafe,
        outras: productCheckIcmsOthers,
        desconto: productCheckIcmsDiscount,
      },
      IPI: {
        frete: productCheckIpiFreight,
        seguro: productCheckIpiSafe,
        outras: productCheckIpiOthers,
        desconto: productCheckIpiDiscount,
      },
      PIS: {
        frete: productCheckPisFreight,
        seguro: productCheckPisSafe,
        outras: productCheckPisOthers,
        desconto: productCheckPisDiscount,
        descIcms: productCheckPisDescIcms,
      },
      COFINS: {
        frete: productCheckCofinsFreight,
        seguro: productCheckCofinsSafe,
        outras: productCheckCofinsOthers,
        desconto: productCheckCofinsDiscount,
        descIcms: productCheckCofinsDescIcms,
      },
    };
  }, [
    productCheckIcmsFreight,
    productCheckIcmsSafe,
    productCheckIcmsOthers,
    productCheckIcmsDiscount,
    productCheckIpiFreight,
    productCheckIpiSafe,
    productCheckIpiOthers,
    productCheckIpiDiscount,
    productCheckPisFreight,
    productCheckPisSafe,
    productCheckPisOthers,
    productCheckPisDiscount,
    productCheckPisDescIcms,
    productCheckCofinsFreight,
    productCheckCofinsSafe,
    productCheckCofinsOthers,
    productCheckCofinsDiscount,
    productCheckCofinsDescIcms,
  ]);

  const getValidateBcTaxation = (taxation) => {
    return {
      ICMS: {
        frete: taxation?.frete_icms === "0",
        seguro: taxation?.seguro_icms === "0",
        outras: taxation?.outras_icms === "0",
        desconto: taxation?.desconto_icms === "0",
      },
      IPI: {
        frete: taxation?.frete_ipi === "0",
        seguro: taxation?.seguro_ipi === "0",
        outras: taxation?.outras_ipi === "0",
        desconto: taxation?.desconto_ipi === "0",
      },
      PIS: {
        frete: taxation?.frete_pis === "0",
        seguro: taxation?.seguro_pis === "0",
        outras: taxation?.outras_pis === "0",
        desconto: taxation?.desconto_pis === "0",
        descIcms: taxation?.desc_icms_pis === 0,
      },
      COFINS: {
        frete: taxation?.frete_cofins === "0",
        seguro: taxation?.seguro_cofins === "0",
        outras: taxation?.outras_cofins === "0",
        desconto: taxation?.desconto_cofins === "0",
        descIcms: taxation?.desc_icms_cofins === 0,
      },
    };
  };

  const calcBc = useCallback(
    ({
      unityValue,
      quantity,
      freightValue,
      safeValue,
      expenseValue,
      discountValue,
      reductPercent,
      mvaPercent,
      type,
      taxation,
      vlrTotal,
      handle = false,
    }) => {
      let tax = null;

      if (handle) {
        tax = taxation;
      } else if (taxation) {
        tax = getValidateBcTaxation(taxation);
      }

      let baseCalculo = parseFloat(unityValue || 0) * parseFloat(quantity || 0);
      baseCalculo = parseFloat(baseCalculo.toFixed(2));

      if (!tax || tax[type]?.frete) baseCalculo += rmd(freightValue || "0,00");
      if (!tax || tax[type]?.seguro) baseCalculo += rmd(safeValue || "0,00");
      if (!tax || tax[type]?.outras) baseCalculo += rmd(expenseValue || "0,00");
      if (!tax || tax[type]?.desconto)
        baseCalculo -= rmd(discountValue || "0,00");
      if (!tax || tax[type]?.descIcms) {
        const icmsValue =
          rmd(productIcmsValue) > 0
            ? rmd(productIcmsValue)
            : calcByAliquot(vlrTotal, parseFloat(taxation.p_icms));
        baseCalculo -= icmsValue || "0,00";
      }

      if (rmd(mvaPercent || "0,00")) {
        baseCalculo = ((100 + rmd(mvaPercent)) * baseCalculo) / 100;
      }

      let reductPercentString;
      let separadorDecimal;

      if (typeof reductPercent === "number") {
        // 1. Se for um float, converte para string usando o ponto (padrão JS)
        reductPercentString = reductPercent.toString();
        separadorDecimal = ".";
      } else {
        // 2. Se for string, usa o valor ou o default "0,0000".
        reductPercentString = reductPercent || "0,0000";

        // 3. Verifica qual separador está sendo usado na string
        if (reductPercentString.includes(",")) {
          separadorDecimal = ",";
        } else if (reductPercentString.includes(".")) {
          separadorDecimal = ".";
        } else {
          separadorDecimal = null;
        }
      }

      let casasDecimais = 0;

      if (separadorDecimal) {
        const separadorIndexOf = reductPercentString.indexOf(separadorDecimal);

        if (separadorIndexOf !== -1) {
          // O número de casas é o total do comprimento menos a posição do separador menos 1
          casasDecimais = reductPercentString.length - 1 - separadorIndexOf;
        }
      }

      if (rmd(reductPercent || "0,0000", casasDecimais)) {
        baseCalculo =
          ((100 - rmd(reductPercent, casasDecimais)) * baseCalculo) / 100;
      }

      return baseCalculo;
    },
    // eslint-disable-next-line
    []
  );

  const getDefaultValuesBc = useCallback(
    (type) => {
      return {
        handle: true,
        taxation: getStatesTaxations(),
        type: type,
        unityValue: rmd(productDataUnityValue, 5),
        quantity: rmd(productDataQuantity, 4),
        freightValue: productOthersFreight,
        safeValue: productOthersSafe,
        expenseValue: productOthersExpense,
        discountValue: productOthersDiscount,
      };
    },
    [
      productDataUnityValue,
      productDataQuantity,
      productOthersFreight,
      productOthersSafe,
      productOthersExpense,
      productOthersDiscount,
      getStatesTaxations,
    ]
  );

  const getDefaultProductValuesBc = (product, type) => {
    return {
      taxation: product.taxation,
      type: type,
      unityValue: product.precounitario,
      quantity: product.qtde,
      freightValue: product.frete,
      safeValue: product.seguro,
      expenseValue: product.outrasdesp,
      discountValue: product.desconto,
      vlrTotal: product.vlr_total,
    };
  };

  const calcIcmsSt = useCallback((bcIcmsSt, percentAliquot, valueIcms) => {
    const initialCalc = calcByAliquot(bcIcmsSt, percentAliquot);

    let icmsStValue = initialCalc - valueIcms;
    if (icmsStValue < 0) icmsStValue = 0;

    return icmsStValue;
  }, []);

  const handleIpiSituation = useCallback(() => {
    if (productIpiSituation) {
      const bcIpi = calcBc(getDefaultValuesBc("IPI"));
      setProductIpiBcValue(MaskService.toMask("decimal", bcIpi.toFixed(2)));
    }
  }, [productIpiSituation, getDefaultValuesBc, calcBc, setProductIpiBcValue]);

  const handleCalcIpi = useCallback(() => {
    if (rmd(productIpiBcValue) && rmd(productIpiAliquot)) {
      const valorIpi = calcByAliquot(
        rmd(productIpiBcValue),
        rmd(productIpiAliquot)
      );

      setProductIpiValue(MaskService.toMask("decimal", valorIpi.toFixed(2)));
    }
  }, [productIpiAliquot, productIpiBcValue, setProductIpiValue]);

  const handleCalcIpiReturned = useCallback(() => {
    if (rmd(productDataTotalValue) && rmd(productIpiReturnedAliquot)) {
      const valorIpiDevolvido = calcByAliquot(
        rmd(productDataTotalValue),
        rmd(productIpiReturnedAliquot)
      );

      setProductIpiReturnedValue(
        MaskService.toMask("decimal", valorIpiDevolvido.toFixed(2))
      );
    }
  }, [
    productIpiReturnedAliquot,
    productDataTotalValue,
    setProductIpiReturnedValue,
  ]);

  const handlePisSituation = useCallback(() => {
    const rulesPisCofins = getRulesPisCofins();

    if (productPisSituation && rulesPisCofins[productPisSituation.value]) {
      const bcPis = calcBc(getDefaultValuesBc("PIS"));
      setProductPisBcValue(MaskService.toMask("decimal", bcPis.toFixed(2)));
    }
  }, [getDefaultValuesBc, calcBc, setProductPisBcValue, productPisSituation]);

  const handleCalcPis = useCallback(() => {
    const rulesPisCofins = getRulesPisCofins();
    if (
      productPisSituation &&
      rulesPisCofins[productPisSituation.value] &&
      rmd(productPisBcValue)
    ) {
      let valorPis = 0;
      if (rmd(productPisPercentAliquot)) {
        valorPis = calcByAliquot(
          rmd(productPisBcValue),
          rmd(productPisPercentAliquot)
        );

        setProductPisValue(MaskService.toMask("decimal", valorPis.toFixed(2)));
      } else if (rmd(productPisAliquot)) {
        valorPis = calcByValue(
          rmd(productPisAliquot),
          parseFloat(productDataQuantity)
        );

        setProductPisValue(MaskService.toMask("decimal", valorPis.toFixed(2)));
      }
    }
  }, [
    productPisPercentAliquot,
    productPisAliquot,
    productPisBcValue,
    productPisSituation,
    setProductPisValue,
    productDataQuantity,
  ]);

  const handleCofinsSituation = useCallback(() => {
    const rulesPisCofins = getRulesPisCofins();
    if (
      productCofinsSituation &&
      rulesPisCofins[productCofinsSituation.value]
    ) {
      const bcCofins = calcBc(getDefaultValuesBc("COFINS"));
      setProductCofinsBcValue(
        MaskService.toMask("decimal", bcCofins.toFixed(2))
      );
    }
  }, [
    getDefaultValuesBc,
    calcBc,
    productCofinsSituation,
    setProductCofinsBcValue,
  ]);

  const handleCalcCofins = useCallback(() => {
    const rulesPisCofins = getRulesPisCofins();
    if (
      productCofinsSituation &&
      rulesPisCofins[productCofinsSituation.value] &&
      rmd(productCofinsBcValue)
    ) {
      let valorCofins = 0;

      if (rmd(productCofinsPercentAliquot) > 0) {
        valorCofins = calcByAliquot(
          rmd(productCofinsBcValue),
          rmd(productCofinsPercentAliquot)
        );
      } else if (rmd(productCofinsAliquot) > 0) {
        valorCofins = calcByValue(
          rmd(productCofinsAliquot),
          parseFloat(productDataQuantity)
        );
      }

      setProductCofinsValue(
        MaskService.toMask("decimal", valorCofins.toFixed(2))
      );
    }
  }, [
    productCofinsPercentAliquot,
    productCofinsAliquot,
    productCofinsBcValue,
    productCofinsSituation,
    setProductCofinsValue,
    productDataQuantity,
  ]);

  const handleFcpIcms = useCallback(() => {
    if (productIcmsSituation) {
      const bc = calcBc(getDefaultValuesBc("ICMS"));

      setProductIcmsBcPoverty(MaskService.toMask("decimal", bc.toFixed(2)));

      let valorFcpIcms = 0;

      if (rmd(productIcmsAliquotPoverty)) {
        valorFcpIcms = calcByAliquot(bc, rmd(productIcmsAliquotPoverty));
      }

      setProductIcmsValuePoverty(
        MaskService.toMask("decimal", valorFcpIcms.toFixed(2))
      );
    }
  }, [
    getDefaultValuesBc,
    calcBc,
    productIcmsSituation,
    productIcmsAliquotPoverty,
    setProductIcmsValuePoverty,
    setProductIcmsBcPoverty,
  ]);

  const handleFcpIcmsDi = useCallback(() => {
    let valorFcpIcms = 0;
    valorFcpIcms = calcByAliquot(
      rmd(productIcmsValueBc),
      rmd(productIcmsAliquotPoverty)
    );
    setProductIcmsValuePoverty(
      MaskService.toMask("decimal", valorFcpIcms.toFixed(2))
    );

    setProductIcmsBcPoverty(MaskService.toMask("decimal", productIcmsValueBc));
  }, [
    productIcmsAliquotPoverty,
    productIcmsValueBc,
    setProductIcmsBcPoverty,
    setProductIcmsValuePoverty,
  ]);

  const handleFcpIcmsSt = useCallback(() => {
    if (productIcmsSituation) {
      const bc = calcBc(getDefaultValuesBc("ICMS"));

      setProductIcmsStBcPoverty(MaskService.toMask("decimal", bc.toFixed(2)));

      let valorFcpIcmsSt = 0;

      if (rmd(productIcmsStAliquotPoverty)) {
        valorFcpIcmsSt = calcByAliquot(bc, rmd(productIcmsStAliquotPoverty));
      }

      setProductIcmsStValuePoverty(
        MaskService.toMask("decimal", valorFcpIcmsSt.toFixed(2))
      );
    }
  }, [
    getDefaultValuesBc,
    calcBc,
    productIcmsSituation,
    productIcmsStAliquotPoverty,
    setProductIcmsStValuePoverty,
    setProductIcmsStBcPoverty,
  ]);

  const handleCreditIcms = useCallback(
    (icmsSituation = null, aliquotCredit = null) => {
      const rulesPerCst = getRulesPerCst;
      let situation = icmsSituation ? icmsSituation : productIcmsSituation;
      let aliquot = aliquotCredit ? aliquotCredit : productIcmsAliquotCredit;

      if (situation && rulesPerCst[situation.value]["vCredICMSSN"]) {
        const bc = calcBc(getDefaultValuesBc("ICMS"));

        let valorCreditIcms = 0;

        if (rmd(aliquot)) {
          valorCreditIcms = calcByAliquot(bc, rmd(aliquot));
        }

        setProductIcmsCreditAprove(
          MaskService.toMask("decimal", valorCreditIcms.toFixed(2))
        );
      }
    },
    [
      productIcmsSituation,
      calcBc,
      getDefaultValuesBc,
      productIcmsAliquotCredit,
      getRulesPerCst,
      setProductIcmsCreditAprove,
    ]
  );

  const handleCalcBCIcms = useCallback(() => {
    const valuesBc = getDefaultValuesBc("ICMS");
    valuesBc.reductPercent = productIcmsPercentReduct;

    let bcIcms = calcBc(valuesBc);

    setProductIcmsValueBc(MaskService.toMask("decimal", bcIcms.toFixed(2)));
  }, [
    getDefaultValuesBc,
    calcBc,
    productIcmsPercentReduct,
    setProductIcmsValueBc,
  ]);

  const handleCalcIcms = useCallback(() => {
    const icmsValue = calcByAliquot(
      rmd(productIcmsValueBc),
      rmd(productIcmsAliquot)
    );
    setProductIcmsValue(MaskService.toMask("decimal", icmsValue.toFixed(2)));
  }, [productIcmsValueBc, productIcmsAliquot, setProductIcmsValue]);

  const handleCalcIcmsInterstate = useCallback(() => {
    if (
      productIcmsAliquotInterstate !== "0,00" ||
      productIcmsValue === "0,00"
    ) {
      const icmsValue = calcByAliquot(
        rmd(productIcmsValueBc),
        rmd(productIcmsAliquotInterstate)
      );
      setProductIcmsValue(MaskService.toMask("decimal", icmsValue.toFixed(2)));
    }
  }, [
    productIcmsAliquotInterstate,
    productIcmsValue,
    productIcmsValueBc,
    setProductIcmsValue,
  ]);

  const handleCalcIcmsSt = useCallback(() => {
    const icmsStValue = calcIcmsSt(
      rmd(productIcmsStValueBc),
      rmd(productIcmsStAliquot),
      rmd(productIcmsValue)
    );

    setProductIcmsStValue(
      MaskService.toMask("decimal", icmsStValue.toFixed(2))
    );
  }, [
    calcIcmsSt,
    productIcmsValue,
    productIcmsStAliquot,
    setProductIcmsStValue,
    productIcmsStValueBc,
  ]);

  const handleCalcBcIcmsSt = useCallback(() => {
    const valuesBc = getDefaultValuesBc("ICMS");
    valuesBc.mvaPercent = productIcmsStPercentAdd;
    valuesBc.discountValue = productIcmsStPercentReductBc;

    const bcIcmsSt = calcBc(valuesBc);

    setProductIcmsStValueBc(MaskService.toMask("decimal", bcIcmsSt.toFixed(2)));
  }, [
    getDefaultValuesBc,
    calcBc,
    productIcmsStPercentAdd,
    productIcmsStPercentReductBc,
    setProductIcmsStValueBc,
  ]);

  const calcsIcmsStTaxations = (taxation, product) => {
    const rulesPerCst = getRulesPerCst;
    /* Icms ST */
    const icmsSt = {
      prodIcmsStModalidade:
        productIcmsStListModality.find(
          (value) => taxation.mod_bc_icms_st === value.value
        ) || null,
      prodIcmsStPercentualAdd: parseFloat(
        taxation?.tributacaost?.[0]?.p_mva_icms_st || 0
      ),
      prodIcmsStPercentualBc: parseFloat(taxation?.p_red_bc_icms_st || 0),
      prodIcmsStValorBc: 0,
      prodIcmsStAliquota: parseFloat(
        taxation?.tributacaost?.[0]?.p_icms_st || 0
      ),
      prodIcmsStValor: 0,
      prodIcmsStAliquotaPob: parseFloat(taxation?.p_icms_fcp_st || 0),
      prodIcmsStBcPob: 0,
      prodIcmsStValorPob: 0,
      prodIcmsStBcRetido: 0,
      prodIcmsStValorRetido: 0,
      prodIcmsStBcFcpRetido: 0,
      prodIcmsStValorFcpRetido: 0,
      prodIcmsStAliqFcpRetido: parseFloat(taxation?.p_icms_fcp_st_ret || 0),
    };

    if (taxation?.cst_icms) {
      const cst = taxation.cst_icms;

      const icmsStModality = productIcmsStListModality.find(
        (value) => taxation.mod_bc_icms_st === value.value
      );
      product.taxation = taxation;

      if (icmsStModality) icmsSt["prodIcmsStModalidade"] = icmsStModality;

      if (rulesPerCst[cst]["vBCST"]) {
        const valuesBc = getDefaultProductValuesBc(product, "ICMS");

        valuesBc.reductPercent = icmsSt.prodIcmsStPercentualBc;
        valuesBc.mvaPercent = icmsSt.prodIcmsStPercentualAdd.toString();

        icmsSt["prodIcmsStValorBc"] = calcBc(valuesBc);
      }

      /* 
        Para o Calculo do ICMS ST é necessário calcular o valor 
        do ICMS antes. Valida se é obrigatorio o vBC para calculo 
      */
      if (rulesPerCst[cst]["vICMSST"]) {
        /* BC do Icms para Calculo do ICMS */
        const valuesBc = getDefaultProductValuesBc(product, "ICMS");

        valuesBc.reductPercent = taxation.p_red_bc_icms;

        const bcIcms = calcBc(valuesBc);
        let icmsValue = calcByAliquot(bcIcms, parseFloat(taxation.p_icms));

        /* Utiliza a BC do ICMS ST previamente calculada */
        icmsSt["prodIcmsStValor"] = calcIcmsSt(
          icmsSt.prodIcmsStValorBc,
          icmsSt.prodIcmsStAliquota,
          icmsValue
        );
      }
    }

    return icmsSt;
  };

  const calcsIcmsTaxations = (taxation, product) => {
    const rulesPerCst = getRulesPerCst;

    const prodIcmsAliquotaPob =
      headerCfop.toString()[0] === "6" && taxation.tributacaointerestadual?.[0]
        ? taxation.tributacaointerestadual?.[0].p_icms_fcp
        : taxation.p_icms_fcp;

    const icms = {
      prodOrigem: null,
      prodIcmsSituacao: null,
      prodIcmsModalidade: null,
      prodIcmsValorBc: 0,
      prodIcmsAliquota:
        parseFloat(
          taxation.tributacaointerestadual?.[0]?.p_icms_interestadual || 0
        ) || parseFloat(taxation.p_icms || 0),
      prodIcmsValor: 0,
      prodIcmsPercentualReductBc: parseFloat(taxation.p_red_bc_icms || 0),
      prodIcmsAliqAplicCred: parseFloat(taxation.p_cred_icms_sn || 0),
      prodIcmsCredAprov: 0,
      prodIcmsValorDes: 0,
      prodIcmsAliquotaPob: parseFloat(prodIcmsAliquotaPob || 0),
      prodIcmsBcPob: 0,
      prodIcmsValorPob: 0,
      prodIcmsAliquotaCons: parseFloat(taxation.pst || 0),
      prodIcmsPropSubs: 0,
      prodIcmsAliquotaInterestadual: parseFloat(
        taxation.tributacaointerestadual?.[0]?.p_icms_interestadual || 0
      ),
      prodIcmsAliquotaInternaDest: parseFloat(
        taxation.tributacaointerestadual?.[0]?.p_icms_interna_destino || 0
      ),
      prodCheckIcmsFrete: taxation?.frete_icms === "0",
      prodCheckIcmsSeguro: taxation?.seguro_icms === "0",
      prodCheckIcmsOutras: taxation?.outras_icms === "0",
      prodCheckIcmsDesconto: taxation?.desconto_icms === "0",
    };

    if (taxation?.cst_icms) {
      const cst = taxation.cst_icms;

      let icmsSituation = null;
      if (queryParams.crt === "1" || queryParams.crt === "4") {
        icmsSituation = productIcmsListSimpleTaxationSituation.find(
          (value) => taxation.cst_icms === value.value
        );
      } else {
        icmsSituation = productIcmsListNormalTaxationSituation.find(
          (value) => taxation.cst_icms === value.value
        );
      }

      if (icmsSituation) icms["prodIcmsSituacao"] = icmsSituation;

      const icmsModality = productIcmsListModality.find(
        (value) => taxation.mod_bc_icms === value.value
      );

      if (icmsModality) icms["prodIcmsModalidade"] = icmsModality;

      const icmsSource = productIcmsListSource.find(
        (value) => taxation.origem === value.value
      );

      if (icmsSource) icms["prodOrigem"] = icmsSource;

      if (rulesPerCst[cst]["vBC"]) {
        product.taxation = taxation;
        const valuesBc = getDefaultProductValuesBc(product, "ICMS");

        valuesBc.reductPercent = icms.prodIcmsPercentualReductBc;

        icms["prodIcmsValorBc"] = calcBc(valuesBc);
      }

      if (rulesPerCst[cst]["vCredICMSSN"] && icms.prodIcmsAliqAplicCred) {
        product.taxation = taxation;
        const valuesBcToCred = getDefaultProductValuesBc(product, "ICMS");

        valuesBcToCred.reductPercent = icms.prodIcmsPercentualReductBc;

        icms.prodIcmsCredAprov = calcByAliquot(
          calcBc(valuesBcToCred),
          icms.prodIcmsAliqAplicCred
        );
      }

      if (rulesPerCst[cst]["vICMS"]) {
        icms["prodIcmsValor"] = calcByAliquot(
          icms.prodIcmsValorBc,
          icms.prodIcmsAliquotaInterestadual || icms.prodIcmsAliquota
        );
      }
    }

    return icms;
  };

  const returnProductObjectsDi = (product) => {
    // cst icms
    let cst_icms = null;
    if (queryParams.crt === "1" || queryParams.crt === "4") {
      cst_icms = productIcmsListSimpleTaxationSituation.find(
        (value) => product.cst_icms.trim() === value.value
      );
    } else {
      cst_icms = productIcmsListNormalTaxationSituation.find(
        (value) => product.cst_icms.trim() === value.value
      );
    }

    // cst cofins
    const cst_cofins = productCofinsListSituation.find(
      (value) => product.cst_cofins.trim() === value.value
    );

    // cst ipi
    const cst_ipi = prodcuctIpiListSituation.find(
      (value) => product.cst_ipi.trim() === value.value
    );

    // cst pis
    const cst_pis = prodcuctPisListSituation.find(
      (value) => product.cst_pis.trim() === value.value
    );

    const origem = productIcmsListSource.find(
      (value) => product.origem.trim() === value.value
    );

    return {
      cst_icms,
      cst_cofins,
      cst_ipi,
      cst_pis,
      origem,
    };
  };

  const calcsIpiTaxations = (taxation, product) => {
    const ipi = {
      prodIpiSituacao: null,
      prodIpiBcValor: 0,
      prodIpiAliquota: taxation?.p_ipi ? parseFloat(taxation.p_ipi) : 0,
      prodIpiValor: 0,
      prodIpiCenq: taxation?.cenq || "",
      prodCheckIpiFrete: taxation?.frete_ipi === "0",
      prodCheckIpiSeguro: taxation?.seguro_ipi === "0",
      prodCheckIpiOutras: taxation?.outras_ipi === "0",
      prodCheckIpiDesconto: taxation?.desconto_ipi === "0",
    };

    if (taxation?.cst_ipi) {
      const ipiSituation = prodcuctIpiListSituation.find(
        (value) => taxation.cst_ipi === value.value
      );

      if (ipiSituation) ipi["prodIpiSituacao"] = ipiSituation;

      /* Calculo pela Aliquota */
      if (ipi.prodIpiAliquota) {
        product.taxation = taxation;
        const bcIpi = calcBc(getDefaultProductValuesBc(product, "IPI"));

        ipi["prodIpiValor"] = calcByAliquot(bcIpi, ipi.prodIpiAliquota);

        if (ipi.prodIpiValor) {
          ipi["prodIpiBcValor"] = bcIpi;
        }
      }
    }

    return ipi;
  };

  const calcsCofinsTaxations = (taxation, product) => {
    const cofins = {
      prodCofinsSituacao: null,
      prodCofinsBcValor: 0,
      prodCofinsAliquota: parseFloat(taxation.vl_cofins || 0),
      prodCofinsPercentualAliquota: parseFloat(taxation.p_cofins || 0),
      prodCofinsValor: 0,
      prodCheckCofinsFrete: taxation?.frete_cofins === "0",
      prodCheckCofinsSeguro: taxation?.seguro_cofins === "0",
      prodCheckCofinsOutras: taxation?.outras_cofins === "0",
      prodCheckCofinsDesconto: taxation?.desconto_cofins === "0",
      prodCheckCofinsDescIcms: taxation?.desc_icms_cofins === 0,
    };

    if (taxation?.cst_cofins) {
      const cofinsSituation = productCofinsListSituation.find(
        (value) => taxation.cst_cofins === value.value
      );

      if (cofinsSituation) cofins["prodCofinsSituacao"] = cofinsSituation;

      if (cofins.prodCofinsAliquota || cofins.prodCofinsPercentualAliquota) {
        product.taxation = taxation;
        const bcCofins = calcBc(getDefaultProductValuesBc(product, "COFINS"));

        let cofinsValue = 0;

        /* Calculo pela Aliquota */
        if (cofins.prodCofinsPercentualAliquota !== 0) {
          cofinsValue = calcByAliquot(
            bcCofins,
            cofins.prodCofinsPercentualAliquota
          );
        } else {
          /* Ou calculo pelo Valor */
          cofinsValue = calcByValue(
            cofins.prodCofinsAliquota,
            parseInt(product.quantidade)
          );
        }
        cofins["prodCofinsValor"] = cofinsValue;

        if (cofinsValue) {
          cofins["prodCofinsBcValor"] = bcCofins;
        }
      }
    }

    return cofins;
  };

  const calcsPisTaxations = (taxation, product) => {
    const pis = {
      prodPisSituacao: null,
      prodPisBcValor: 0,
      prodPisAliquota: parseFloat(taxation.vl_pis || 0),
      prodPisPercentualAliquota: parseFloat(taxation.p_pis || 0),
      prodPisValor: 0,
      prodCheckPisFrete: taxation?.frete_pis === "0",
      prodCheckPisSeguro: taxation?.seguro_pis === "0",
      prodCheckPisOutras: taxation?.outras_pis === "0",
      prodCheckPisDesconto: taxation?.desconto_pis === "0",
      prodCheckPisDescIcms: taxation?.desc_icms_pis === 0,
    };

    if (taxation?.cst_pis) {
      const pisSituation = prodcuctPisListSituation.find(
        (value) => taxation.cst_pis === value.value
      );

      if (pisSituation) pis["prodPisSituacao"] = pisSituation;

      if (pis.prodPisAliquota || pis.prodPisPercentualAliquota) {
        product.taxation = taxation;
        const bcPis = calcBc(getDefaultProductValuesBc(product, "PIS"));

        let pisValue = 0;

        /* Calculo pela Aliquota */
        if (pis.prodPisPercentualAliquota) {
          pisValue = calcByAliquot(bcPis, pis.prodPisPercentualAliquota);
        } else {
          /* Ou calculo pelo Valor */
          pisValue = calcByValue(
            pis.prodPisAliquota,
            parseInt(product.quantidade)
          );
        }
        pis["prodPisValor"] = pisValue;

        if (pisValue) {
          pis["prodPisBcValor"] = bcPis;
        }
      }
    }

    return pis;
  };

  const calcTotalsNfe = useCallback(
    (itens = []) => {
      let itensTableCopy = [];
      if (itens.length) {
        itensTableCopy = itens;
      } else {
        itensTableCopy = [...itensTable];
      }

      let totalValueIcms = 0;
      let totalBaseIcms = 0;
      let totalIcmsFcp = 0;
      let totalIcmsDes = 0;
      let totalValueSt = 0;
      let totalBaseSt = 0;
      let totalStFcp = 0;
      let totalValueIpi = 0;
      let totalValueIpiReturned = 0;
      let totalValuePis = 0;
      let totalValueCofins = 0;
      let totalValueCustoms = 0;
      let totalFreight = 0;
      let totalSafe = 0;
      let totalOthers = 0;
      let totalDiscount = 0;
      let total = 0;
      let totalProductValue = 0;
      let totalValueII = 0;
      let totalValueDespAdu = 0;
      // let totalStWithheld = 0; //VERIFICAR

      itensTableCopy.forEach((value) => {
        total++;

        if (value.prodIcmsModalidade) {
          totalValueIcms += value.prodIcmsValor ? rmd(value.prodIcmsValor) : 0;
          totalBaseIcms += rmd(value.prodIcmsValorBc);
          totalIcmsDes += rmd(value.prodIcmsValorDes);
          totalIcmsFcp += rmd(value.prodIcmsValorPob);
        }

        if (value.prodIcmsStModalidade) {
          totalValueSt += rmd(value.prodIcmsStValor);
          totalBaseSt += rmd(value.prodIcmsStValorBc);
          totalStFcp += rmd(value.prodIcmsStValorPob);
        }

        totalValueIpi += rmd(value.prodIpiValor);
        totalValueIpiReturned += rmd(value.prodIpiDevolvidoValor);
        totalValuePis += rmd(value.prodPisValor);
        totalValueCofins += rmd(value.prodCofinsValor);
        totalValueCustoms += rmd(value.prodIIValorAduaneiro);
        totalFreight += rmd(value.prodFrete);
        totalSafe += rmd(value.prodSeguro);
        totalOthers += rmd(value.prodDespesas);
        totalDiscount += rmd(value.prodDesconto, 5);
        totalProductValue += rmd(value.prodValorTotal);
        totalValueII += rmd(value.prodIIImpostoImportacao);
        totalValueDespAdu += rmd(value.prodIIDespAdu);

        // totalStWithheld += rmd("decimal",value.prod); //VERIFICAR
      });

      /*  Calculo do Total da NF-e  */
      let totalValueNFE =
        totalProductValue -
        totalDiscount -
        totalIcmsDes +
        totalValueSt +
        totalFreight +
        totalSafe +
        totalOthers +
        totalValueIpi +
        totalValueIpiReturned +
        totalValueII +
        totalValueDespAdu;

      const totals = {
        totalValueIcms,
        totalBaseIcms,
        totalIcmsFcp,
        totalIcmsDes,
        totalValueSt,
        totalBaseSt,
        totalStFcp,
        totalValueIpi,
        totalValueIpiReturned,
        totalValuePis,
        totalValueCofins,
        totalValueCustoms,
        totalFreight,
        totalSafe,
        totalOthers,
        totalDiscount,
        totalProductValue,
        totalValueNFE:
          nfeMontageSubtype === "DI" ? totalBaseIcms : totalValueNFE,
        totalValueII,
        totalValueDespAdu,
        total,
      };

      return totals;
    },
    // eslint-disable-next-line
    [itensTable, nfeMontageSubtype]
  );

  const taxationFormat = (productItem) => {
    return {
      /**
       * ICMS
       */
      p_icms: rmd(productItem.prodIcmsAliquota || "0,00"),
      p_red_bc_icms: rmd(productItem.prodIcmsPercentualReductBc || "0,0000", 4),
      p_cred_icms_sn: rmd(productItem.prodIcmsCredAprov || "0,00"),
      p_icms_fcp: rmd(productItem.prodIcmsAliquotaPob || "0,00"),
      pst: rmd(productItem.prodIcmsAliquotaCons || "0,00"),
      cst_icms: productItem.prodIcmsSituacao?.value || null,
      mod_bc_icms: productItem.prodIcmsModalidade?.value || null,
      origem: productItem.prodOrigem?.value || null, //(?)

      /**
       * ICMS ST
       */
      p_mva_icms_st: rmd(productItem.prodIcmsStPercentualAdd || "0,00"),
      p_red_bc_icms_st: rmd(productItem.prodIcmsStPercentualBc || "0,00"),
      p_icms_fcp_st: rmd(productItem.prodIcmsStAliquotaPob || "0,00"),
      p_icms_fcp_st_ret: rmd(productItem.prodIcmsStAliqFcpRetido || "0,00"),
      cst_icms_st: productItem.prodIcmsSituacao?.value || null,
      mod_bc_icms_st: productItem.prodIcmsStModalidade?.value || null,

      /**
       * IPI
       */
      p_ipi: rmd(productItem.prodIpiAliquota || "0,00"),
      cst_ipi: productItem.prodIpiSituacao?.value || null,

      /**
       * COFINS
       */
      vl_cofins: rmd(productItem.prodCofinsValor || "0,00"),
      p_cofins: rmd(productItem.prodCofinsPercentualAliquota || "0,00"),
      cst_cofins: productItem.prodCofinsSituacao?.value || null,

      /**
       * PIS
       */
      vl_pis: rmd(productItem.prodPisValor || "0,00"),
      p_pis: rmd(productItem.prodPisPercentualAliquota || "0,00"),
      cst_pis: productItem.prodPisSituacao?.value || null,
    };
  };

  const productFormat = (productItem) => {
    return {
      idItem: productItem.idItem || null,
      vlr_total: rmd(productItem.prodValorTotal || "0,00"),
      precounitario: rmd(productItem.prodValorUnitario || "0,00000", 5),
      frete: rmd(productItem.prodFrete || "0,00"),
      seguro: rmd(productItem.prodSeguro || "0,00"),
      outrasdesp: rmd(productItem.prodDespesas || "0,00"),
      desconto: rmd(productItem.prodDesconto || "0,00000", 5),
      quantidade: rmd(productItem.prodQuantidade || "0,00"),
      unidade: productItem.prodUn,
      unidade_entrega: productItem.prodUnEntrega,
      gtin: productItem.prodGtin,
      cest: productItem.prodCest,
      observacao: productItem.prodAdicional,
      qtde: rmd(productItem.prodQuantidade || "0,0000", 4),
      cfop: productItem.prodCfop,
      descricao: productItem.prodDescricao,
      codigo: productItem.prodCodigo,
      idestoque: productItem.prodIdEstoque,
      ncm: productItem.prodNcm,
    };
  };

  const apportionmentPercent = (valueToApportion, productTotalValue) => {
    return (valueToApportion / productTotalValue) * 100;
  };

  const apportionmentProdcut = (productValue, percent) => {
    return (productValue * percent) / 100;
  };

  const apportionment = (value, divider) => {
    const aux = Math.floor((value / divider) * 100);
    const chargeFinalValue = aux / 100;

    const rest = value - chargeFinalValue * divider;

    return {
      parcel: chargeFinalValue,
      rest: rest,
    };
  };

  const handleCalcPaymentCondition = ({
    newValueNfe,
    paymentConditionCopy,
    paymentsConditionNumber,
  }) => {
    const precautionCopy = JSON.parse(JSON.stringify(paymentConditionCopy));
    try {
      const liquidetTotal = paymentConditionCopy.reduce(
        (accumulator, payment) => {
          if (
            payment.cobrancaSituacaoValue ===
              GlobalVariables.RecieveSituations.fullyLiquidated ||
            payment.cobrancaSituacaoValue ===
              GlobalVariables.RecieveSituations.partiallyLiquidated
          ) {
            return accumulator + rmd(payment?.cobrancaValor);
          }

          return accumulator + 0;
        },
        0
      );
      let lastIndex = 0;
      if (liquidetTotal < newValueNfe) {
        let valueToEach =
          (newValueNfe - liquidetTotal) / paymentsConditionNumber;

        valueToEach = valueToEach < 0.0 ? 0.0 : valueToEach;

        paymentConditionCopy.map((payment, index) => {
          if (
            payment.cobrancaSituacaoValue !==
              GlobalVariables.RecieveSituations.fullyLiquidated &&
            payment.cobrancaSituacaoValue !==
              GlobalVariables.RecieveSituations.partiallyLiquidated
          ) {
            lastIndex = index;
            payment.cobrancaValor = MaskService.toMask(
              "decimal",
              valueToEach.toFixed(2),
              2
            );
          }
          return payment;
        });
      }
      // Parte do código que verifica se há alguma diferença de 0,01 centavos,
      // Caso haja ele soma ou subtrai na última ocorrência de codição de pagamento
      // Que não seja parcialmente ou totalmente liquidado
      const finalValue = paymentConditionCopy.reduce((accumulator, payment) => {
        return accumulator + rmd(payment?.cobrancaValor);
      }, 0);

      if (finalValue !== newValueNfe) {
        const valueRest = parseFloat((newValueNfe - finalValue).toFixed(2));
        const lastValueIndex = rmd(
          paymentConditionCopy[lastIndex].cobrancaValor
        );
        let recalculatedValue = lastValueIndex - valueRest * -1;

        recalculatedValue = recalculatedValue < 0.0 ? 0.0 : recalculatedValue;

        paymentConditionCopy[lastIndex].cobrancaValor = MaskService.toMask(
          "decimal",
          recalculatedValue.toFixed(2),
          2
        );
      }
    } catch (error) {
      paymentConditionCopy = JSON.parse(JSON.stringify(precautionCopy));
      notify(
        "Não foi possível recalcular as condições de pagamento. Por favor faça as alterações manualmente.",
        true,
        "warning"
      );
    }
  };

  const handleCalcPaymentForm = ({
    newValueNfe,
    oldValueNfe,
    paymentFormCopy,
    paymentsFormNumber,
  }) => {
    const precautionCopy = JSON.parse(JSON.stringify(paymentFormCopy));

    try {
      //  Se o campo "Forma de Pagamento" estiver preenchido com apenas 1 forma de pagamento ,
      // o sistema deve atualizar o valor da forma de pagamento com o valor da nota fiscal
      let lastIndex = paymentsFormNumber - 1;
      if (paymentsFormNumber === 1) {
        paymentFormCopy.map((payment) => {
          payment.pagtoValor = MaskService.toMask(
            "decimal",
            newValueNfe.toFixed(2),
            2
          );

          return payment;
        });
      }
      // Se houver mais de uma forma de pagamento, ambas diferente de “Sem Pagamento”, o sistema deve calcular a diferença entre o valor
      // anterior e o novo valor da nota fiscal,
      if (paymentsFormNumber > 1) {
        const totalDiferenceValue = newValueNfe - oldValueNfe;

        const allEqual = paymentFormCopy.every(
          (payment, i, paymentArray) =>
            rmd(payment.pagtoValor) === rmd(paymentArray[0].pagtoValor)
        );

        if (allEqual) {
          // Se houver formas de pagamento com o mesmo valor, a diferença calculada no item anterior
          // deve ser adicionada ou retirada proporcionalmente de todas as formas de pagamento com base em seus valores iniciais.
          const proratedValue = totalDiferenceValue / paymentsFormNumber;
          paymentFormCopy.map((payment) => {
            const newValue =
              newValueNfe > 0.0
                ? rmd(payment.pagtoValor) - proratedValue * -1
                : 0.0;
            payment.pagtoValor = MaskService.toMask(
              "decimal",
              newValue.toFixed(2),
              2
            );
            return payment;
          });
        } else {
          // Se não houver formas de pagamento com o mesmo valor a diferença calculada
          // deve ser adicionada ou retirada da forma de pagamento de maior valor.
          const maxPayment = paymentFormCopy.reduce((prev, current) =>
            prev && rmd(prev.pagtoValor) > rmd(current.pagtoValor)
              ? prev
              : current
          );

          const newValue =
            rmd(maxPayment.pagtoValor) - totalDiferenceValue * -1;

          let valueToEach = newValueNfe / paymentsFormNumber;

          paymentFormCopy.map((payment, index) => {
            if (newValue > 0) {
              if (payment.index === maxPayment.index) {
                payment.pagtoValor = MaskService.toMask(
                  "decimal",
                  newValue.toFixed(2),
                  2
                );
                lastIndex = index;
              }
            } else {
              payment.pagtoValor = MaskService.toMask(
                "decimal",
                valueToEach.toFixed(2),
                2
              );
              lastIndex = index;
            }
            return payment;
          });
        }

        // Parte do código que verifica se há alguma diferença de 0,01 centavos,
        // Caso haja ele soma ou subtrai na última ocorrência de codição de pagamento
        // Que não seja parcialmente ou totalmente liquidado
        const finalValue = paymentFormCopy.reduce((accumulator, payment) => {
          return accumulator + rmd(payment?.pagtoValor);
        }, 0);

        if (finalValue !== newValueNfe) {
          const valueRest = parseFloat((newValueNfe - finalValue).toFixed(2));
          const lastValueIndex = rmd(paymentFormCopy[lastIndex].pagtoValor);

          let recalculatedValue = lastValueIndex - valueRest * -1;
          recalculatedValue = recalculatedValue < 0.0 ? 0.0 : recalculatedValue;

          paymentFormCopy[lastIndex].pagtoValor = MaskService.toMask(
            "decimal",
            recalculatedValue.toFixed(2),
            2
          );
        }
      }
    } catch (error) {
      paymentFormCopy = JSON.parse(JSON.stringify(precautionCopy));
      notify(
        "Não foi possível recalcular as formas de pagamento. Por favor faça as alterações manualmente.",
        true,
        "warning"
      );
    }
  };

  return {
    calcByAliquot,
    calcByValue,
    calcIcmsSt,
    handleFcpIcmsSt,
    handleFcpIcms,
    handleIpiSituation,
    handleCreditIcms,
    handleCalcIpi,
    handleCalcPis,
    handlePisSituation,
    handleCofinsSituation,
    handleCalcCofins,
    handleCalcBCIcms,
    handleCalcBcIcmsSt,
    handleCalcIcms,
    handleCalcIcmsSt,
    calcsIcmsStTaxations,
    calcsIcmsTaxations,
    calcsIpiTaxations,
    calcsCofinsTaxations,
    calcsPisTaxations,
    calcTotalsNfe,
    apportionment,
    taxationFormat,
    productFormat,
    getRulesPerCst,
    getSuccessStats,
    returnProductObjectsDi,
    handleFcpIcmsDi,
    handleCalcIcmsInterstate,
    apportionmentPercent,
    apportionmentProdcut,
    handleCalcPaymentCondition,
    handleCalcPaymentForm,
    handleCalcIpiReturned,
  };
}
